<template>
  <div class="wrapper pa-0">
    <div class="back">
      <v-btn icon small @click="goBack()">
        <v-icon class="secondary-color text--darken-1">arrow_back</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
    </div>
    <div class="login-card-header">
      <img
        :src="require(`@/assets/logos/usecargoazul.png`)"
        alt="pickndrive"
        style="width: 200px; margin-bottom: 12%; margin-top: 12%"
      />
    </div>
    <div class="text-start pt-0 pa-3 px-8">
      <span class="title font-weight-regular ">
        Contato para o caso de sinistros, manutenção ou outros:
      </span>
    </div>

    <div class="text-center pb-2">
      <!-- <v-flex class="pb-3">
        <v-btn outlined large class="checkin-text" href="tel:3133172081">
          <v-icon class="checkin-text">phone</v-icon>
          <span class="font-weight-regular title pl-2">(31) 3317-2081</span>
        </v-btn>
      </v-flex> -->

      <v-flex class="pb-3">
        <v-btn large class="colorBtn" @click="openChat()">
          <v-icon left>perm_phone_msg</v-icon>
          <span class="font-weight-regular title">CHAT 24HRS</span>
        </v-btn>
      </v-flex>
    </div>
    <v-flex class="text-center px-4">
      <span class="font-weight-regular body-2">contato@usecargo.mobi</span>
    </v-flex>

    <div class="text-center px-4">
      <v-divider class="grey lighten-1 mx-3 my-4"></v-divider>
      <v-flex class="text-start px-4 pt-1">
        <span class="title font-weight-regular">Como Usar:</span>
      </v-flex>
      <v-flex class="text-start px-4 pt-3">
        <span class="text--lighten-3 font-weight-regular body-2"
          >O vídeo explicativo contém todos os passos para a utilização do
          aplicativo, para assisti-lo clique no botão abaixo.</span
        >
      </v-flex>
      <v-flex class="mt-3">
        <v-btn
          outlined
          large
          class="checkin-text"
          href="https://www.youtube.com/watch?v=uUDqWG4R_Xk"
        >
          <v-icon left class="checkin-text">videocam</v-icon>
          <span class="font-weight-regular checkin-text title"
            >ASSISTIR VÍDEO</span
          >
        </v-btn>
      </v-flex>
    </div>

    <div class="text-center px-4 bottom" style="width:100%">
      <v-divider class="mx-3 my-4"></v-divider>
      <span class="title font-weight-regular">Perguntas Frequentes:</span>

      <v-list-group v-model="value" no-action>
        <template v-slot:activator>
          <v-list-item-title style="font-weight: bold"
            >Cadastro</v-list-item-title
          >
        </template>
        <v-expansion-panels focusable>
          <v-expansion-panel
            v-for="(pergunta, i) in perguntas.cadastro"
            :key="i"
          >
            <v-expansion-panel-header>
              {{ pergunta.p }}
            </v-expansion-panel-header>
            <v-expansion-panel-content class="px-4">
              {{ pergunta.r }}
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-list-group>

      <v-list-group v-model="value" no-action>
        <template v-slot:activator>
          <v-list-item-title style="font-weight: bold"
            >Regras</v-list-item-title
          >
        </template>
        <v-expansion-panels focusable>
          <v-expansion-panel v-for="(pergunta, i) in perguntas.regras" :key="i">
            <v-expansion-panel-header>
              {{ pergunta.p }}
            </v-expansion-panel-header>
            <v-expansion-panel-content class="px-4">
              {{ pergunta.r }}
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-list-group>

      <v-list-group v-model="value" no-action>
        <template v-slot:activator>
          <v-list-item-title style="font-weight: bold"
            >Pontos Importante</v-list-item-title
          >
        </template>
        <v-expansion-panels focusable>
          <v-expansion-panel
            v-for="(pergunta, i) in perguntas.pontosImportantes"
            :key="i"
          >
            <v-expansion-panel-header>
              {{ pergunta.p }}
            </v-expansion-panel-header>
            <v-expansion-panel-content class="px-4">
              {{ pergunta.r }}
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-list-group>

      <v-list-group v-model="value" no-action>
        <template v-slot:activator>
          <v-list-item-title style="font-weight: bold"
            >Reabastecimento</v-list-item-title
          >
        </template>
        <v-expansion-panels focusable>
          <v-expansion-panel
            v-for="(pergunta, i) in perguntas.reabastecimento"
            :key="i"
          >
            <v-expansion-panel-header>
              {{ pergunta.p }}
            </v-expansion-panel-header>
            <v-expansion-panel-content class="px-4">
              {{ pergunta.r }}
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-list-group>

      <v-list-group v-model="value" no-action>
        <template v-slot:activator>
          <v-list-item-title style="font-weight: bold"
            >Valores</v-list-item-title
          >
        </template>
        <v-expansion-panels focusable>
          <v-expansion-panel
            v-for="(pergunta, i) in perguntas.valores"
            :key="i"
          >
            <v-expansion-panel-header>
              {{ pergunta.p }}
            </v-expansion-panel-header>
            <v-expansion-panel-content class="px-4">
              {{ pergunta.r }}
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-list-group>

      <v-list-group v-model="value" no-action>
        <template v-slot:activator>
          <v-list-item-title style="font-weight: bold"
            >Cupons</v-list-item-title
          >
        </template>
        <v-expansion-panels focusable>
          <v-expansion-panel v-for="(pergunta, i) in perguntas.cupons" :key="i">
            <v-expansion-panel-header>
              {{ pergunta.p }}
            </v-expansion-panel-header>
            <v-expansion-panel-content class="px-4">
              {{ pergunta.r }}
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-list-group>

      <v-list-group v-model="value" no-action>
        <template v-slot:activator>
          <v-list-item-title style="font-weight: bold"
            >Pagamentos e reembolso</v-list-item-title
          >
        </template>
        <v-expansion-panels focusable>
          <v-expansion-panel
            v-for="(pergunta, i) in perguntas.pagamentoReembolso"
            :key="i"
          >
            <v-expansion-panel-header>
              {{ pergunta.p }}
            </v-expansion-panel-header>
            <v-expansion-panel-content class="px-4">
              {{ pergunta.r }}
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-list-group>

      <v-list-group v-model="value" no-action>
        <template v-slot:activator>
          <v-list-item-title style="font-weight: bold"
            >Sinistros</v-list-item-title
          >
        </template>
        <v-expansion-panels focusable>
          <v-expansion-panel
            v-for="(pergunta, i) in perguntas.sinistros"
            :key="i"
          >
            <v-expansion-panel-header>
              {{ pergunta.p }}
            </v-expansion-panel-header>
            <v-expansion-panel-content class="px-4">
              {{ pergunta.r }}
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-list-group>

      <v-list-group v-model="value" no-action placeholder="aa">
        <template v-slot:activator>
          <v-list-item-title style="font-weight: bold"
            >Outros</v-list-item-title
          >
        </template>
        <v-expansion-panels focusable>
          <v-expansion-panel v-for="(pergunta, i) in perguntas.outros" :key="i">
            <v-expansion-panel-header>
              {{ pergunta.p }}
            </v-expansion-panel-header>
            <v-expansion-panel-content class="px-4">
              {{ pergunta.r }}
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-list-group>
    </div>

    <footer class="text-right pa-4" style="width:100%">
      v.{{ version_app }}
    </footer>
  </div>
</template>

<script>
import theming from '../../mixins/theming';
import questions from '../../helpers/help.js';
import packageJsonValues from '../../../package.json';

export default {
  mixins: [theming],

  data() {
    return {
      perguntas: questions,
      version_app: null,
    };
  },
  created() {
    this.getVersion();
  },
  methods: {
    goBack() {
      this.$router.push('/');
    },
    openChat() {
      this.$zendesk.zE('webWidget', 'open');
    },
    getVersion() {
      this.version_app = packageJsonValues.version;
    },
  },
};
</script>

<style scoped>
.secondary-color .body-2 .title {
  color: var(--secondary-color) !important;
}

.wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  /*background: url("../../assets/background-desktop.png");*/
  background-color: white;
  z-index: 2;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: scroll;
}

.colorSelectedBack {
  background-color: var(--secondary-color);
}
.sizeTop {
  height: 48px;
}

.bottom {
  margin-bottom: 60px;
}

.container {
  position: relative;
  height: 100vh;
}

.checkin {
  background-color: white;
  text-decoration: none;
  text-transform: none;
  color: var(--primary-color) !important;
}

.checkin-text {
  text-decoration: none;
  text-transform: none;
  color: var(--secondary-color) !important;
}

.colorBtn {
  text-decoration: none;
  text-transform: none;
  background-color: var(--primary-color) !important;
  color: var(--secondary-color) !important;
}

.login-card-header {
  display: flex;
  justify-content: center;
}

.back {
  display: flex;
  position: absolute;
  top: 30px;
  left: 40px;
  color: var(--primary-color) !important;
}

.expansion-title {
  position: relative;
  top: 40px;
  font-weight: bold;
}
</style>
